const KDW = [
    {id: "0", value: "週K"},    
    {id: "1", value: "週D"}   
  ];  
  
  export default KDW